export { Icon } from './Icon';
export { iconSchema } from './schema';
export type { IconType, IconTheme, IconSize } from './Icon';
